import { defineStore } from 'pinia';
import { api } from '../boot/axios'

export const useDepartmentStore = defineStore('department', {
  persist: true,

  state: () => ({
    departments: [],
    departmentsLoading: false
  }),

  getters: {
    getDepartments: (state) => (clientID) => {
      return state.departments.filter(department => department.clientID === clientID)
    }
  },

  actions: {
    saveDepartmentLocally (department) {
      let present = false
      if (this.departments) {
        for (let i = 0; i < this.departments.length; i++) {
          if (this.departments[i].departmentID === department.departmentID) {
            Object.assign(this.departments[i], department)
            present = true
            break
          }
        }
      }
      if (!present) {
        this.departments.push(department)
      }
    },
    async fetchDepartments (clientID) {
      // commit(DEPARTMENT_GET_DEPARTMENTS_PENDING)
      this.departmentsLoading = true
      api
        .get('api/v1/departments/client/' + clientID)
        .then(response => {
          for (let i = 0; i < response.data.length; i++) {
            const department = {
              departmentID: response.data[i].departmentID,
              departmentName: response.data[i].departmentName,
              clientID: clientID
            }
            // commit(DEPARTMENT_GET_DEPARTMENT_SUCCESS, department)
            this.saveDepartmentLocally(department)
          }
          // commit(DEPARTMENT_GET_DEPARTMENTS_SUCCESS)
          this.departmentsLoading = false
        })
        .catch(err => {
          console.error(err)
        })
    },
    postDepartment (department) {
      return new Promise((resolve, reject) => {
        api
          .post('api/v1/departments', {
            departmentEmployerID: department.departmentEmployerID,
            departmentName: department.departmentName
          })
          .then(response => {
            // commit(DEPARTMENT_GET_DEPARTMENT_SUCCESS, )
            this.saveDepartmentLocally({
              departmentName: response.data.departmentName,
              departmentID: response.data.departmentID,
              clientID: department.clientID
            })
            resolve(response.data)
          })
          .catch(err => {
            console.error(err)
            reject(err)
          })
      })
    }
  }

})
